import css from "./InventoryVerify.module.css";
import "./InventoryVerify.css"
import { regUses, useOrdersOfStatus, useRawData, useLanguages, useRichmondData, useTbl } from "../../axios_with_token";
import { DisplayArray, DisplayRcdList, RcdList, useRcdList } from "../../input_types/Tbl/Tbl";
import WWTabs from "../../components/WWTabs/WWTabs";
import { useState, useRef, useLayoutEffect } from "react";


export default function InventoryVerify({}){
    const {regUse, DefaultResponse} = regUses();

    const {data:language, save, getLang} = regUse(useLanguages());
    // [] the following need update after tbl changed

    const { data: dataGot, invalidate } = regUse(useOrdersOfStatus({
        type: 'all',
        opts: {
            filters:{},
            orderby:[],
            expands: [{
                fld: 'buyer',
                tbl: 'entities',
                tblFlds: 'name'
            }],

            page:0, 
            rcdsPerPage: 100
        }
    }));
    const data = (dataGot || {})
    const refData = useRef({
        activeRcdIdx: 0
    });
    
    function CorrectRichmondData({}){
        const {regUse, DefaultResponse} = regUses();

        const {data:tblPdtsGot, invalidate:invalidateTblPdts} = regUse(useTbl('pdts'));
        const tblPdts = tblPdtsGot || {
            rcds: [],
            rcdsById: {},
            timestamp: ''
        };

        
        const [changed, setChanged] = useState(false);
        
        const {data: richmondData, save:saveRichmondData} = regUse(useRawData('richmond_raw_data'));
        const rcdsRichmondData = richmondData||[];
        // [] scroll to active
        useLayoutEffect(_=>{
            console.log('..................scroll to anchor: #', refData.current.activeRcdIdx);
            window.location.hash = `#${refData.current.activeRcdIdx}`;
        })
        return <DefaultResponse>
            <div
                className="container"
            >
                <div
                    className="row fixed-top"
                >
                    <div
                        className="col p-3"
                    ><button
                        disabled = {!changed}
                        className="btn btn-primary"
                        onClick={evt=>{
                            saveRichmondData(rcdsRichmondData).then(rcdsRichmondData=>{
                                setChanged(false);
                            });

                        }}
                    >save</button></div>
                </div>
                <DisplayArray
                    onRcdSaved={(rcd, rcdIdx)=>{
                        refData.current.activeRcdIdx = rcdIdx;
                        setChanged(true); // how to trigger?
                    }}
                    highlightFn={(rcd, rcdIdx)=>{
                        if(!rcd.pdtId)return true;
                        return false;
                    }}
                    rcds={rcdsRichmondData}
                    activeRcdIdx={refData.current.activeRcdIdx}

                    listFlds={'pdtId,pdtSn,pdtBrand,pdtName,qty,origin'}
                    listFldsInputSettings={
                        {
                            pdtId:rcdIn=>{
                                const rcd = rcdIn || {};
                                return {
                                    type: 'search',
                                    srcTbl: 'pdts',
                                    srcSearchFlds: 'sn,name,brandAbbr,description', 
                                    srcShowFlds: 'sn,brandAbbr,name',
                                    getCaption: rcdIn=>{
                                        const rcd = rcdIn || {};
                                        const pdtId = rcd.pdtId;
                                        const pdt = tblPdts.rcdsById[pdtId] || {};
                                        return `${pdt.sn || ''}`;
                                    },
                                    opts:{
                                        allowNew: true,
                                        onDataChanged: _=>{
                                            invalidateTblPdts();
                                        },
                                        // construct and pass in current values
                                        curValues: {
                                                sn: rcd.pdtSn,
                                                brand: rcd.pdtBrand=='WW'?"Willowest":rcd.pdtBrand,
                                                brandAbbr: rcd.pdtBrand,
                                                name: rcd.pdtName
                                            }
                                        }
                                }
                            }
                        }
                    }
                    btns={[
                        // ({})=><div>
                        //     <button type="button"
                        //         className="btn btn-primary"
                        //         title="add new product"
                        //     >+</button>
                        // </div>
                    ]}
                ></DisplayArray>
            </div>
        </DefaultResponse>;
    }
    
    return <DefaultResponse>
        <h1>inventory verify</h1>
        {/* <div>{JSON.stringify(Object.keys((data.rcds||[])[0]))}</div> */}
        <div>{Object.keys((data.rcds||[])[0]||{}).join(',')}</div>
            <WWTabs
                tabDefs={[
                    {
                        caption: 'order list',
                        name:'orderList',
                        active: true,
                        Content: ({})=> <RcdList
                            rcds={data}
                            listFlds={'__orderedItems,__t,__u,amount,attachment,buyer,buyer__xpd__,buyer_address1,buyer_address2,buyer_city,buyer_country,buyer_province,buyer_zip,date,deliveryFee,dir,note,seller,seller_address1,seller_address2,seller_city,seller_country,seller_province,seller_zip,sn,status,tax'}
                            // listFlds={Object.keys((data.rcds||[])[0]||{}).join(',')}
                        ></RcdList>
                    },
                    {
                        caption: 'error',
                        Content:({})=><div>
                            <h3>errors</h3>

                        </div>
                    },
                    {
                        caption: 'correct Richmond data',
                        Content: CorrectRichmondData
                    }
                ]}
            ></WWTabs>            



    </DefaultResponse>;
}

